import type { Industry } from "./industries";
import type { CategoryPrompt } from "./types";

import { accessoriesPrompts } from "./industry-prompts/accessories";
import { activitiesOutdoorPrompts } from "./industry-prompts/activities-outdoor";
import { babyKidsPrompts } from "./industry-prompts/baby-kids";
import { bagsLuggagePrompts } from "./industry-prompts/bags-luggage";
import { beautyPrompts } from "./industry-prompts/beauty";
import { clothingPrompts } from "./industry-prompts/clothing";
import { drinksBeveragesPrompts } from "./industry-prompts/drinks-beverages";
import { foodPrompts } from "./industry-prompts/food";
import { hairCarePrompts } from "./industry-prompts/hair-care";
import { healthWellnessPrompts } from "./industry-prompts/health-wellness";
import { homeDecorPrompts } from "./industry-prompts/home-decor";
import { homeGoodsPrompts } from "./industry-prompts/home-goods";
import { personalCarePrompts } from "./industry-prompts/personal-care";
import { petsPrompts } from "./industry-prompts/pets";
import { shoesPrompts } from "./industry-prompts/shoes";
import { skincarePrompts } from "./industry-prompts/skincare";
import { supplementsPrompts } from "./industry-prompts/supplements";
import { techPrompts } from "./industry-prompts/tech";

export const INDUSTRY_PROMPTS: Record<Industry, CategoryPrompt[]> = {
  Accessories: accessoriesPrompts,
  "Activities & Outdoor": activitiesOutdoorPrompts,
  "Baby & Kids": babyKidsPrompts,
  "Bags & Luggage": bagsLuggagePrompts,
  Beauty: beautyPrompts,
  Clothing: clothingPrompts,
  "Drinks & Beverages": drinksBeveragesPrompts,
  Food: foodPrompts,
  "Hair Care": hairCarePrompts,
  "Health & Wellness": healthWellnessPrompts,
  "Home Goods": homeGoodsPrompts,
  "Home Decor": homeDecorPrompts,
  "Personal Care": personalCarePrompts,
  Pets: petsPrompts,
  Shoes: shoesPrompts,
  Skincare: skincarePrompts,
  Supplements: supplementsPrompts,
  Tech: techPrompts,
};
